import { useGetUserPicQuery } from "@/features/users/usersApiSlice"

const User = ({ username, defaultUserPic }) => {

    // First Created - 07 Jan 2026
    // Author - Atul Pandey
    // Purpose - To componentize the User pic display used in other Trinity comps - i.e. EtUserAccomplishmentWeeklyPadComp


    const { data: userPic, isFetching: isFetchingUserPic } =
      useGetUserPicQuery(username)
  
    return (
      <div className="flex justify-center items-center h-12 w-12 rounded-full border border-white bg-gradient-to-r from-orange-600 to-orange-400 shadow-lg shadow-black cursor-pointer">
        {/* Display user picture or loading indicator*/}
        {isFetchingUserPic ? (
          <div>Loading...</div>
        ) : userPic ? (
          <img src={userPic} alt="User" className="h-11 w-11  rounded-full" />
        ) : (
          <img src={defaultUserPic} alt="User" className="h-10 w-10 p-1" />
        )}
      </div>
    )
  }

  export default User